import React, { Component } from 'react';
import Basic from '../../container/layouts/Basic';

class Stats extends Component {
    state = {  }
    render() {
        return (
            <Basic stats {...this.props}>
                <h4>Statistiques</h4>
            </Basic>
        );
    }
}

export default Stats;